import { useTranslation } from "react-i18next";
import { ProfileFullNames, videoModelHrefs } from "../Layout";
import { scrollIntoView } from "../Helpers/scrollTo";

interface VideosProps {
    shortName?: string;
}
export const Videos = (props: VideosProps) => {
    const { shortName } = props;
    const { t } = useTranslation();
    const name = videoModelHrefs.includes(shortName || '') ? ProfileFullNames[shortName as keyof typeof ProfileFullNames] : ProfileFullNames['Lia'];
    return (
        <div className="box">
            <div className="video-preview">
                <img src={`js/img/${videoModelHrefs.includes(shortName || '') ? shortName : 'Lia'}_Video.jpg`} alt="Video Preview" className="video-preview-image" />
                <div className="icon-bg" onClick={() => scrollIntoView('form_container')}>
                    <span className="icon--ri play-fill font-size-2"></span>
                </div>
            </div>
           <h2 className="margin-top-1">{t('Dein persönliches Willkommens-Video von')} {name}</h2>
           <p>{t('Erhalte ein exklusives Video von {{name}} gratis zur Anmeldung!', { name })}</p>
           <div className="flex-align-flex-start gap-1-half text-color chatting-color">
                <span className="icon--ri gift-line"></span>
                <p className="reset-margin">{t('Kostenlos für dich')}</p>
           </div>
        </div>
    )
}
